import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess } from "../../../../utils/constants";
import { emailValidator } from "../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getStateMasterList_action, deleteStateMaster_action } from "../../../../actions/admin_module_action/master_action/state_master_action";
import Footer from "../../../../common_components/Footer";


class StateList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            countryList: [],
            StateList: [],
            deleteID: '',
            countryID: '',
            stateName: '',
            Status: ''
        }
        this.getFillList = this.getFillList.bind(this)
        this.record = this.record.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.deleteStateMaster = this.deleteStateMaster.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.handleUpdate = this.handleUpdate.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getStateMasterList = this.getStateMasterList.bind(this)
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        this.getFillList(countryActionId, '', '', '', '', '').then(() => {
            this.getStateMasterList()
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === countryActionId) {
                            console.log("country data", data.data)
                            // var internationalCountryData = data.data.length > 0 && data.data.filter((item) => item.Code != "91")
                            this.setState({
                                countryList: data.data
                            })
                        }
                        resolve(true)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    record(list) {
        return (
            <table class="table sticky-table text-nowrap table-bordered mb-0">
                <thead class="table-light">

                    <tr>
                        <th style={{ width: '50px' }}>SR no.</th>
                        <th className="text-center" >State</th>
                        <th className="text-center" >Country</th>
                        <th style={{ width: '50px' }}></th>
                        <th style={{ width: '50px' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr key={Math.random()}>
                                    {/* <td className="text-center">{data.RoleID}</td> */}
                                    {/* <td className="text-center">{moment(data.ExhibitionDateFrom).format('L')}</td>
                                    <td className="text-center">{moment(data.ExhibitionDateTo).format('L')}</td>
                                <td className="text-center">{this.state.countryList.map(id => (parseInt(id.Code) == data.CountryID ? id.Description : null))}</td> */}
                                    <td className="text-center">{i + 1}</td>
                                    <td className="text-center">{data.StateName}</td>
                                    <td className="text-center">{data.CountryName}</td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-aqua"
                                            onClick={(e) => this.handleUpdate(data.StateID)}
                                        >
                                            Update
                                        </button>
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={(e) => this.onDelete(data.StateID)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>)
    }

    getStateMasterList() {
        this.setState({ isLoading: true })
        const { countryID, stateName, Status } = this.state
        console.log('CountryID', countryID)
        this.props.getStateMasterList_action(countryID, stateName, Status)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data[0])
                    this.setState({ StateList: data.data[0] })
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            countryID: '',
            stateName: '',
            Status: ''
        })
        setTimeout(() => {
            this.getStateMasterList()
        }, 100);
    }

    handleAdd() {
        this.props.navigate('/stateMasterAU', { state: { is_add: true, } })
    }

    handleUpdate(id) {
        this.props.navigate('/stateMasterAU', { state: { is_update: true, StateID: id } })
    }

    deleteStateMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteStateMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getStateMasterList()
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onDelete(i) {
        const { } = this.state
        this.setState({ deleteID: i })
        this.setState({ isOpen: true, })
    }

    updateItem(item) {
        const { StateList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = StateList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(StateList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    render() {
        const { isOpen, isLoading, currentPage, StateList, stateName, Status, countryList, countryID } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = StateList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(StateList.length / recordsPerPage)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">State Master List</h6>
                            </div>
                        </div>
                        <div className="admin-top-space p-2">
                            {
                                JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                <div className="row m-0">
                                    <div className="col-md-3">
                                        <label>Country</label>
                                        <select className="form-control"
                                            value={countryID}
                                            onChange={(e) => this.setState({ countryID: e.target.value })}  >
                                            <option value={''}>Select</option>
                                            {
                                                countryList.length > 0 && countryList.map(data => (
                                                    <option value={data.Code} key={data.Code}>{data.Description}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>State</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={stateName}
                                            onChange={(e) => this.setState({ stateName: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Status</label>
                                        <select className="form-control"
                                            value={Status}
                                            onChange={(e) => this.setState({ Status: e.target.value })}  >
                                            <option value={''}>Select</option>
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label></label>
                                        {
                                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID != 1 &&
                                            <div
                                                className="mt-2"
                                                role="group"
                                                aria-label="Basic example"
                                                style={{ float: "right" }}
                                            >
                                                <button type="button" className="btn btn-aqua"
                                                    onClick={e => this.getStateMasterList()}
                                                >
                                                    Search
                                                </button>
                                                <button type="button" className="btn btn-aqua mx-2"
                                                    onClick={e => this.handleAdd()}
                                                >
                                                    Add
                                                </button>
                                                <button type="button" className="btn btn-gray"
                                                    onClick={e => this.clearSearch()}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }

                            <div className="row m-0 mx-2">
                                <div class="table-responsive px-1 sticky-table-wrapper mt-3">
                                    {this.record(currentRecords)}
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                StateList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                    <div className="col-md-3 text-right">
                                        <div className="table-record-pages mt-3" style={{ float: "right" }}>
                                            <p>{`${currentPage} of ${nPages} pages`}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div
                        className="modal-dialog modal-dialog-centered bd-example-modal-lg"
                        id="detail">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content text-center p-4">
                                <h5 className="fw-semibold text-danger mb-2">Are you sure?</h5>
                                <p className="mb-4">Do you really want to delete this record?</p>
                                <div className="d-flex justify-content-center gap-3">
                                    <button
                                        type="button"
                                        className="btn btn-danger px-4"
                                        data-bs-dismiss="modal"
                                        onClick={(e) => this.deleteStateMaster(this.state.deleteID)}
                                    >
                                        Yes
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-gray px-4"
                                        data-bs-dismiss="modal"
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getStateMasterList_action, deleteStateMaster_action })(StateList));